import { useState } from "react";
import { Plus, Loader2 } from "lucide-react";
import { createPhrase } from "@/lib/api";
import { toast } from "sonner";

export default function SaveToDictionary({ text }) {
  const [tags, setTags] = useState("");
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!text.trim()) return;
    setSaving(true);
    try {
      const tagList = tags.split(",").map((t) => t.trim()).filter(Boolean);
      await createPhrase({ text, tags: tagList, notes });
      toast.success(`"${text}" added to dictionary`);
      setTags("");
      setNotes("");
    } catch {
      toast.error("Failed to save phrase");
    } finally {
      setSaving(false);
    }
  };

  return (
    <aside className="panel p-6 h-fit">
      <div className="font-mono text-[10px] uppercase tracking-[0.2em] muted">
        Save to Dictionary
      </div>
      <p className="muted text-xs mt-2 leading-relaxed">
        Add this phrase so it shows up in future number-searches.
      </p>
      <div className="mt-4 space-y-3">
        <div>
          <label className="font-mono text-[10px] uppercase tracking-wider muted">Tags (comma-separated)</label>
          <input
            data-testid="save-tags"
            value={tags}
            onChange={(e) => setTags(e.target.value)}
            placeholder="death, ritual, people"
            className="terminal-input mt-1.5 w-full px-3 py-2 text-sm"
          />
        </div>
        <div>
          <label className="font-mono text-[10px] uppercase tracking-wider muted">Notes</label>
          <textarea
            data-testid="save-notes"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows={3}
            placeholder="Optional context…"
            className="terminal-input mt-1.5 w-full px-3 py-2 text-sm resize-none"
          />
        </div>
        <button
          data-testid="add-phrase-btn"
          onClick={save}
          disabled={saving || !text.trim()}
          className="btn-primary w-full py-3 text-xs flex items-center justify-center gap-2 disabled:opacity-50"
        >
          {saving ? <Loader2 className="animate-spin" size={14} /> : <Plus size={14} />}
          Add Phrase
        </button>
      </div>
    </aside>
  );
}
